import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Button, Popconfirm, Table, Tag } from "antd"
import { useState } from "react"
import { useReactQueryMutation } from "../../hooks/useMutation"
import { UseData } from "../../hooks/useReactQuery"
import { openNotification } from "../../utils/notification"

export default function AnnouncementTable({ handleEdit }) {
  const [visible, setVisible] = useState(null)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const { data, isLoading } = UseData("announcements", "announcement/all")
  const mutation = useReactQueryMutation("announcements", "announcement")

  const deleteHandel = (id, name) => {
    setConfirmLoading(true)
    mutation.mutate(
      {
        id: id,
        method: "DELETE",
      },
      {
        onSuccess: (e) => {
          openNotification("success", `Announcement "${name}" has been deleted.`)
          setVisible(false)
          setConfirmLoading(false)
        },
      }
    )
  }
  const showPopConfirm = (id) => {
    setVisible(id)
  }

  const columns = [
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      render: (text) => text,
    },

    {
      title: "message",
      dataIndex: "message",
      key: "message",
      render: (text) => text,
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <div className="flex space-x-2">
          <Button size="medium" type="primary" shape="circle" icon={<EditOutlined />} onClick={() => handleEdit(record._id)} />
          <Popconfirm
            title={`Are sure you want to delete this "${record.title}" Announcement?`}
            open={record.key === visible}
            onConfirm={() => deleteHandel(record._id, record.title)}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={() => setVisible(false)}
          >
            <Button size="medium" type="primary" danger shape="circle" onClick={() => showPopConfirm(record.key)} icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ]
  const tableData = data.map((d) => ({ key: d._id, ...d }))
  if (tableData.length === 0 && !isLoading) return null
  return (
    <div className="pt-5 border-t border-gray-300 mt-8">
      <h1 className="font-bold text-xl pb-3">All Announcement</h1>
      <Table columns={columns} dataSource={tableData} loading={isLoading} pagination={{ pageSize: 100 }} />
    </div>
  )
}
